import { useEffect, useMemo, useState } from "react";
import { norm, shuffle, speak } from "@/lib/speech";

export const OrderExercise = ({ ex, lang, locked, onSubmit }) => {
  const bank = useMemo(() => shuffle(ex.tokens.map((t, i) => ({ t, i }))), [ex]);
  const [line, setLine] = useState([]);
  useEffect(() => setLine([]), [ex]);
  const sep = lang === "ja" ? "" : " ";
  const correct = ex.tokens.join(sep);

  const check = () => {
    const attempt = line.map((x) => x.t).join(sep);
    speak(correct, lang);
    onSubmit(norm(attempt).replace(/ /g, "") === norm(correct).replace(/ /g, ""), correct);
  };

  return (
    <div>
      <div className="rounded-2xl bg-slate-50 border border-slate-200 p-4 mb-4">
        <p className="caption mb-1">Build this sentence</p>
        <p className="text-lg font-semibold text-slate-900">{ex.prompt}</p>
      </div>
      <div data-testid="order-answer-line" className="min-h-[64px] border-b-2 border-dashed border-slate-300 flex flex-wrap gap-2 pb-3 mb-5">
        {line.map((x) => (
          <button key={x.i} disabled={locked} data-testid={`order-placed-${x.i}`} onClick={() => setLine(line.filter((y) => y.i !== x.i))} className="token-chip bg-[hsl(var(--primary-light))] border-[hsl(var(--primary))]/40">
            {x.t}
          </button>
        ))}
      </div>
      <div className="flex flex-wrap gap-2 justify-center">
        {bank.map((x) => {
          const used = line.some((y) => y.i === x.i);
          return (
            <button key={x.i} disabled={used || locked} data-testid={`order-token-${x.i}`} onClick={() => setLine([...line, x])} className={`token-chip ${used ? "opacity-30" : ""}`}>
              {x.t}
            </button>
          );
        })}
      </div>
      {!locked && (
        <button data-testid="exercise-check-button" disabled={line.length !== ex.tokens.length} onClick={check} className="btn-primary w-full mt-6">
          Check
        </button>
      )}
    </div>
  );
};
